import React, { useState } from "react"
import PhotoPlaceholder from "../PhotoPlaceholder"

const Thumbnails = ({ photos, onOpen }) => {
  const [failed, setFailed] = useState(false)

  if (!photos?.length) {
    return (
      <div className="w-full h-40 md:w-44 md:h-32 rounded-xl overflow-hidden shrink-0">
        <PhotoPlaceholder />
      </div>
    )
  }

  return (
    <button
      onClick={() => onOpen(0)}
      className="relative w-full h-40 md:w-44 md:h-32 rounded-xl overflow-hidden shrink-0 group focus:outline-none focus-visible:ring-2 focus-visible:ring-[#FF6B3D] focus-visible:ring-offset-2 focus-visible:ring-offset-[#F4F6F9]"
    >
      {failed ? (
        <PhotoPlaceholder />
      ) : (
        <img
          src={photos[0]}
          alt="Room preview"
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
          onError={() => setFailed(true)}
        />
      )}
      {photos.length > 1 && (
        <span className="absolute bottom-1.5 right-1.5 text-[10px] font-medium bg-black/55 text-white px-1.5 py-0.5 rounded-full">
          +{photos.length - 1}
        </span>
      )}
    </button>
  )
}

export default Thumbnails
